import React, { useState, useEffect } from "react";
import { TextField, Button, Typography, Container, Box } from "@mui/material";
import Layout from "../../../../layout/Layout";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addAmenitiesList,
  getAmenitiesList,
  editAmenitiesList,
} from "../../../../services/coworking/amenitiesListAPI";

const AddEditCoworkingAmenities = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  let location = useLocation();
  location = location.pathname.slice(1);

  const isEditMode =
    location === "add-new-coworking-amenities-list" ? false : true;

  const [amenitiesListData, setAmenitiesListData] = useState({
    icon: "",
    iconAltText: "",
    title: "",
  });

  useEffect(() => {
    if (id) {
      getAmenitiesList(id)
        .then((data) => {
          setAmenitiesListData({
            icon: data.icon,
            iconAltText: data.icon_alt_text,
            title: data.title,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [id]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setAmenitiesListData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const newAmenitiesListData = {
      icon: amenitiesListData.icon,
      icon_alt_text: amenitiesListData.iconAltText,
      title: amenitiesListData.title,
    };
    if (isEditMode) {
      editAmenitiesList(id, newAmenitiesListData)
        .then((response) => {
          setAmenitiesListData({
            icon: "",
            iconAltText: "",
            title: "",
          });

          navigate("/coworking-amenities-list");
        })
        .catch((error) => {
          console.error("Greška pri ažuriranju:", error);
        });
    } else {
      addAmenitiesList(newAmenitiesListData)
        .then((response) => {
          setAmenitiesListData({
            ...amenitiesListData,
            icon: response.icon,
            iconAltText: response.icon_alt_text,
            title: response.title,
          });
          navigate("/coworking-amenities-list");
        })
        .catch((error) => {
          console.error("Greška pri dodavanju", error);
        });
    }
  };

  const handleBack = () => {
    // Handle Back action here
  };

  return (
    <Layout>
      <div>
        <Box style={{ display: "flex" }}>
          <Link
            to="/coworking-amenities-list"
            style={{ textDecoration: "none" }}
          >
            <Button variant="outlined" onClick={handleBack}>
              <ArrowBackIcon />
              Back
            </Button>
          </Link>
        </Box>
        <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
          Coworking Amenities List
        </Typography>

        <form onSubmit={handleSubmit}>
          <div>
            <TextField
              sx={{ marginTop: "30px" }}
              name="icon"
              label="Icon"
              value={amenitiesListData.icon}
              fullWidth
              onChange={handleInputChange}
            />
          </div>
          <div>
            <TextField
              sx={{ marginTop: "30px" }}
              name="iconAltText"
              label="Icon Alt Text"
              value={amenitiesListData.iconAltText}
              fullWidth
              onChange={handleInputChange}
            />
          </div>
          <div>
            <TextField
              sx={{ marginTop: "30px" }}
              name="title"
              label="Title"
              value={amenitiesListData.title}
              fullWidth
              onChange={handleInputChange}
            />
          </div>

          <Container
            sx={{
              marginTop: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              sx={{ m: 1, width: "25ch" }}
              type="submit"
              size="medium"
              variant="outlined"
            >
              {location === "add-new-coworking-amenities-list"
                ? "Publish"
                : "Save"}
            </Button>
          </Container>
        </form>
      </div>
    </Layout>
  );
};

export default AddEditCoworkingAmenities;
